export default __webpack_public_path__ + "static/media/5.bd5715df.webp";